import { InputAdornment } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';

interface Props {
  disabled?: boolean;
}

export const ExpertRatingTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <DefaultFastTextField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.propertyoverview.fields.expertRating.label')}
      fieldName="investmentDetails.expertRating"
      type="number"
      endAdornment={<InputAdornment position="end">/5</InputAdornment>}
      inputProps={{ min: 0, max: 5, step: 0.1 }}
    />
  );
};
